import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Datafield, Datafields } from 'src/app/models/database/datafield.model';
import { PepService } from 'src/app/services/http/pep/pep.service';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';

@Component({
  selector: 'app-reorder-section-fields',
  templateUrl: './reorder-section-fields.component.html',
  styleUrls: ['./reorder-section-fields.component.scss']
})
export class ReorderSectionFieldsComponent implements OnInit {

  @Input() sectionFields: Datafields

  @ViewChild('reorderSectionFieldsModal') reorderSectionFieldsModal: TemplateRef<any>
  modalReference: NgbModalRef

  reorderingSectionFields: boolean

  @Output('onSectionFieldsReorder') sectionFieldWereReordered: Subject<number> = new Subject<number>()

  constructor(
    private _modalService: NgbModal,
    private _pepService: PepService,
    private _snackbar: SnackbarService,
  ) { }

  ngOnInit(): void {
  }

  openModal(): void {
    this._orderDatafields()
    this.reorderingSectionFields = false
    this.modalReference = this._modalService.open(this.reorderSectionFieldsModal)
  }

  dropDatafield(event: CdkDragDrop<Datafields>): void {
    moveItemInArray(this.sectionFields, event.previousIndex, event.currentIndex)
  }

  reorderDatafields(): void {
    this._orderDatafields()
    const sectionId: number = this.sectionFields[0].datasheetSessionId
    const sectionFields: { _id: string, order: number }[] =
      this.sectionFields.map((sectionField: Datafield) => {
        return {
          _id: sectionField._id,
          order: sectionField.order
        }
      })
    this.reorderingSectionFields = true
    this._pepService.reorderSectionFields(sectionId, sectionFields)
      .subscribe((sectionId: number | null) => {
        if (sectionId) {
          this.sectionFieldWereReordered.next(sectionId)
          this.modalReference.close()
          this._snackbar.show('Campos reordenados.')
          return
        }
        this._snackbar.showError('Campos não foram reordenados, por favor tente novamente mais tarde.')
        this.reorderingSectionFields = false
      })
  }

  private _orderDatafields(): void {
    this.sectionFields = this.sectionFields.map((datafield: Datafield) => {
      let orderedDatafield: Datafield = { ...datafield }
      orderedDatafield.order = this.sectionFields.indexOf(datafield)
      return orderedDatafield
    })
  }
}
